import styled from '@emotion/styled';
import { EmotionBreakpoint, useBrandDetails } from 'dw-au-react-components';
import React, { useState } from 'react';
import Slider from 'react-slick';
const StyledRecruitmentModal = styled.div`
	${EmotionBreakpoint('mobile')} {
		display: flex;
		flex-direction: column;
	}
	.slick-initialized .slick-slide {
		height: auto;
	}

	.product__image {
		max-height: 120px;
		width: auto !important;
		min-height: auto !important;
		margin-right: 40px !important;
		transition: all 0.3s ease-in-out;
	}

	.slick-slider {
		margin-bottom: 0 !important;
	}

	.slick-slide {
		margin: 0px !important;
		padding-right: 10px;
	}

	.slick-prev,
	.slick-next {
		background: none !important;
	}

	.slick-next::after {
		right: 3px;
	}

	.slick-prev::after {
		left: 3px;
	}

	.slick-next,
	.slick-next:hover {
		right: -45px !important;
		${EmotionBreakpoint('mobile')} {
			right: -15px !important;
			top: -20%;
		}
	}

	.slick-prev,
	.slick-prev:hover {
		left: -45px !important;
		${EmotionBreakpoint('mobile')} {
			left: -15px !important;
			top: -20%;
		}
	}
	.slick-current .product__image {
		max-height: 192px;
	}

	.slider-1 {
		.slick-slide {
			min-height: 192px;
			display: flex;
			align-items: center;
		}
	}

	.col__divider {
		flex: 1;
		height: 200px;
		${EmotionBreakpoint('mobile')} {
			height: auto;
		}
	}
	.general__info {
		max-height: 25px;
		margin-bottom: 30px !important;
	}
	.title {
		min-width: 100px;
	}
	.quantity {
		letter-spacing: 1px;
		width: auto;
	}
`;

function RecruitmentCasesModal({ product, modalItemCode }) {
	const { country } = useBrandDetails();
	let modalProduct = product.filter((item) => {
		return item.itemCode === modalItemCode;
	});

	const [nav1, setNav1] = useState();
	const [nav2, setNav2] = useState();

	let slickSettings = {
		slidesToShow: 6,
		responsive: [
			{
				breakpoint: 575,
				settings: {
					arrows: false,
					slidesToShow: 3,
					centerMode: true,
				},
			},
		],
	};

	return (
		<StyledRecruitmentModal id='slider__items'>
			<div className='slider-1 pb-40'>
				<Slider
					{...slickSettings}
					asNavFor={nav2}
					focusOnSelect={true}
					adaptiveHeight={true}
					variableWidth={true}
					infinite={true}
					centerMode={true}
					ref={(slider1) => setNav1(slider1)}
				>
					{modalProduct[0]?.content?.map((item, index) => {
						let referencedProduct = item?.referencedProduct;
						let itemCode = referencedProduct?.itemCode;
						let productName = `${referencedProduct.name}${
							referencedProduct?.vintage ? ' ' + referencedProduct?.vintage : ''
						}`;
						return (
							<img
								key={index}
								className='img-responsive product__image mx-auto cursor-pointer'
								src={`/images/${
									country?.toLowerCase() || 'au'
								}/en/product/${itemCode}.png`}
								onError={(e) => {
									if (!e.target.src.includes(referencedProduct.largeImage)) {
										e.target.src = referencedProduct.largeImage;
									} else {
										e.target.onerror = null;
										e.target.src =
											'/images/au/common/new_default_bottle_thumb.png';
									}
								}}
								alt={productName}
								title={productName}
								loading='lazy'
							/>
						);
					})}
				</Slider>
			</div>

			<div className='slider-2'>
				<Slider
					asNavFor={nav1}
					ref={(slider2) => setNav2(slider2)}
					slidesToShow={1}
					swipeToSlide={true}
					adaptiveHeight={true}
					infinite={true}
				>
					{modalProduct[0]?.content?.map((item, index) => {
						let quantity = item?.quantity;
						let referencedProduct = item?.referencedProduct;
						return (
							<div key={index}>
								<div className='text-uppercase roboto mb-15 text-dark-medium text_small quantity'>
									{quantity}{' '}
									{referencedProduct.productType === 'nonfoodsundry' ||
									referencedProduct.productType === 'foodsundry'
										? 'Item'
										: 'Bottle'}
									{quantity > 1 ? 's' : ''}
								</div>
								<h5 className='mb-20'>{`${referencedProduct.name}${
									referencedProduct?.vintage
										? ' ' + referencedProduct?.vintage
										: ''
								}`}</h5>
								{referencedProduct?.longDescription ? (
									<div
										className='mb-20 text-dark-medium'
										dangerouslySetInnerHTML={{
											__html: referencedProduct.longDescription,
										}}
									></div>
								) : referencedProduct?.description ? (
									<div
										className='mb-20 text-dark-medium'
										dangerouslySetInnerHTML={{
											__html: referencedProduct.description,
										}}
									></div>
								) : null}
								{referencedProduct.productType !== 'nonfoodsundry' &&
								referencedProduct.productType !== 'foodsundry' ? (
									<>
										<div className='subtitle mb-20'>Wine File</div>
										<div className='more__info__section d-flex justify-content-between align-items-start flex-wrap'>
											<div className='col__divider d-flex flex-wrap flex-column'>
												{referencedProduct.styleName && (
													<div className='general__info d-flex'>
														<div className='font-weight-bold title'>Style</div>
														<div className='text-dark-medium'>
															{referencedProduct.styleName}
														</div>
													</div>
												)}
												{referencedProduct.countryName && (
													<div className='general__info d-flex'>
														<div className='font-weight-bold title'>
															Country
														</div>
														<div className='text-dark-medium'>
															{referencedProduct.countryName}
														</div>
													</div>
												)}
												{referencedProduct.grapeName && (
													<div className='general__info d-flex'>
														<div className='font-weight-bold title'>Grape</div>
														<div className='text-dark-medium'>
															{referencedProduct.grapeName}
														</div>
													</div>
												)}
												{referencedProduct.drinkByDateAsString && (
													<div className='general__info d-flex'>
														<div className='font-weight-bold title'>
															Drink by
														</div>
														<div className='text-dark-medium'>
															{referencedProduct.drinkByDateAsString}
														</div>
													</div>
												)}
												{referencedProduct.alcoholPercent && (
													<div className='general__info d-flex'>
														<div className='font-weight-bold title'>
															Alcohol
														</div>
														<div className='text-dark-medium'>
															{referencedProduct.alcoholPercent}%
														</div>
													</div>
												)}
												{referencedProduct.alcoholUnits && (
													<div className='general__info d-flex'>
														<div className='font-weight-bold title'>Units</div>
														<div className='text-dark-medium'>
															{referencedProduct.alcoholUnits}
														</div>
													</div>
												)}
												{referencedProduct.bottleSize && (
													<div className='general__info d-flex'>
														<div className='font-weight-bold title'>
															Bottle size
														</div>
														<div className='text-dark-medium'>
															{referencedProduct.bottleSize} mls
														</div>
													</div>
												)}
											</div>
										</div>
									</>
								) : null}
							</div>
						);
					})}
				</Slider>
			</div>
		</StyledRecruitmentModal>
	);
}

export default RecruitmentCasesModal;
